import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Links between pull requests and the Jira tasks they cover. One pull request can cover several tasks, and one task can go through several pull requests.',
    name: 'Pull Request Requirement Links',
    partialId: PartialId.Standard.create('pr_req_links'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
